import './App.css';
import ReactGA from 'react-ga4';
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Header from './Components/Header';
import ProtectedRoute from './Components/ProtectedRoute';
import Dashboard from './Components/Dashboard';
import Format from './Pages/Format';
// import { getDeviceToken, SignIn, SignOut } from './utils'
import Homepage from './Pages/Homepage';

// import db from './firebase'
const TRACKING_ID = "G-7L7BFTC2HM"; // MEASUREMENT_ID
ReactGA.initialize(TRACKING_ID);

function App() {

  return (
    <BrowserRouter>
      <Header />
      <Routes>

        {/* HOME ROUTE */}
        <Route path="/" element={<Homepage />} />

        <Route path="/format" element={<Format />} />

        {/* PROTECTED ROUTE */}
        <Route element={<ProtectedRoute />} >
          <Route path='/dashboard' element={<Dashboard />} />
          {/* ADD MORE IF NEEDED */}
        </Route>

      </Routes>

    </BrowserRouter>
  );
}

export default App;
